import React, { useEffect, useState } from 'react';
import { Form, Input, Row, Col, Modal, message, Image, Select } from 'antd';
import {getSpaceUrl} from 'utils/api'

import { FilePond, registerPlugin } from 'react-filepond'
import { useTranslation } from "react-i18next";

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

const UpdateRoomModal = (props) => {
  const [form] = Form.useForm();

  const { TextArea } = Input;
  const { t } = useTranslation();
  const [roomImg, setRoomImg] = useState('')
  const [files, setFiles] = useState([])

  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
      if (props.roomVsaDevices) {
        console.log("Room VSA Devices:",props.roomVsaDevices)
        setSelectedValues(props.roomVsaDevices);
      }
    }, [props.roomVsaDevices]);
  

  useEffect(() => {
		if (props.selectedRoom){
      form.setFieldValue(props.selectedRoom)
      if (props.selectedRoom.IMAGE_NAME){
        setRoomImg(getSpaceUrl() + props.selectedRoom.IMAGE_NAME)
      }
    }
	}, [props.selectedRoom])

  useEffect((()=>{
    if (files.length > 0){
      console.log(files)
      files.map(fileItem => {
        console.log(fileItem.file)
        props.upload(fileItem.file)
      })
    }
  }),[files])

  const onFinish = (values) => {
    if (props.uploadImg == null) {
      // message.warning(t("rooms.PleaseUploadRoomImage"));
      // return;
    }
    console.log("Selected VSA Devices:",selectedValues)
    props.updateRoomVsaDevices(props.selectedRoom.ROOM_UUID,selectedValues)
    props.action(values);
    props.close();
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error(t("rooms.OnlyImageFilesAllowed"));
    }
    return isImage;
  };

  return (
    <Modal
      title={t("rooms.updateRoom")}
      open={true}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={props.selectedRoom}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("rooms.roomName")}
              name="ROOM_NAME"
              rules={[{ required: true, message: t("rooms.enterRoomName") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("rooms.roomLocation")}
              name="ROOM_LOC"
              rules={[{ required: true, message: t("rooms.enterRoomLocation") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("rooms.roomLength")}
              name="ROOM_X"
              rules={[{ required: true, message: t("rooms.enterRoomLength") }]}
            >
              <Input type='number' />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("rooms.roomWidth")}
              name="ROOM_Y"
              rules={[{ required: true, message: t("rooms.enterRoomWidth") }]}
            >
              <Input type='number' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t("rooms.description")}
              name="INFO"
            >
              <TextArea />
            </Form.Item>
          </Col>

          {
            props.enableVSA && (
            <Col span={24}>
              <Form.Item
                label={t("vsa.assign_vsa_device")}
                rules={[{ message: t("vsa.validation_vsa_device_message") }]}
              >
                <Select
                  mode="multiple"
                  placeholder={t("vsa.select_vsa_device")}
                  value={selectedValues}
                  onChange={setSelectedValues}
                  options={props.vsaDevices}
                />
              </Form.Item>
            </Col>
          )
          }

          <Col span={24}>
            <Form.Item
              label={t("rooms.uploadRoomImage")}
              name="image"
            >
              <FilePond
                files={files}
                onupdatefiles={setFiles}
                allowMultiple={false}
                maxFiles={1}
                name="files"
                labelIdle={t("rooms.DragDropOrBrowse")}
              />
            </Form.Item>
          </Col>

          {roomImg && !props.uploadImg ? (
            <Col span={24}>
              <Image src={roomImg} />
            </Col>
          ) : null}
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateRoomModal;